import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveDynamicComponent as _resolveDynamicComponent, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { PropType } from 'vue';
import { Routes } from '../../constants/enums';
import DashboardIcon from './DashboardIcon.vue';
import TimelineIcon from './TimelineIcon.vue';
import PhotosIcon from './PhotosIcon.vue';
import DocumentsIcon from './DocumentsIcon.vue';
import WarrantyIcon from './WarrantyIcon.vue';
import MessagesIcon from './MessagesIcon.vue';
import AccountIcon from './AccountIcon.vue';
import HomeIcon from './HomeIcon.vue';


export default /*#__PURE__*/_defineComponent({
  props: {
  name: {
    type: String as PropType<Routes>,
    required: true,
    validation: (v) => Object.values(Routes).includes(v),
  },
},
  setup(__props) {

const props = __props

const icon = (() => {
  switch (props.name) {
    case Routes.DASHBOARD:
      return DashboardIcon;

    case Routes.TIMELINE:
      return TimelineIcon;

    case Routes.MESSAGES:
      return MessagesIcon;

    case Routes.PHOTOS:
      return PhotosIcon;

    case Routes.DOCUMENTS:
      return DocumentsIcon;

    case Routes.WARRANTY:
      return WarrantyIcon;

    case Routes.MY_ACCOUNT:
      return AccountIcon;

    case Routes.HOMES:
      return HomeIcon;
    /* no default */
  }
})();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_resolveDynamicComponent(_unref(icon))))
}
}

})